import { render } from "./WordInfoWidget.vue?vue&type=template&id=7fd2c75c&scoped=true"
import script from "./WordInfoWidget.vue?vue&type=script&lang=js"
export * from "./WordInfoWidget.vue?vue&type=script&lang=js"

import "./WordInfoWidget.vue?vue&type=style&index=0&id=7fd2c75c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd2c75c"]])

export default __exports__